import { render, staticRenderFns } from "./keywordPdd.vue?vue&type=template&id=47bbb310&scoped=true"
import script from "./keywordPdd.vue?vue&type=script&lang=js"
export * from "./keywordPdd.vue?vue&type=script&lang=js"
import style0 from "./keywordPdd.vue?vue&type=style&index=0&id=47bbb310&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bbb310",
  null
  
)

export default component.exports